import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Card } from "reactstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getAllOrder } from 'Services/Features/Order/Utils/orderUtils';
import CustomLoader from 'Component/Common/CustomLoader';
import FindOrder from './Filter/FindOrder';
import OrderContent from './OrderContent';
import { setFilters, resetFilters } from 'Services/Features/Order/orderSlice';
import { GetAdminRole } from 'Component/Common/GetAdminRole';

const OrderContain = () => {
    const dispatch = useDispatch();
    const orders = useSelector((state) => state.order.orders);
    const loading = useSelector((state) => state.order.loading);
    const error = useSelector((state) => state.order.error);
    const [refetch, setRefetch] = useState(false);
    const filters = useSelector(state => state.order.filters);

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('USER'));
        const role = GetAdminRole(user);

        let newFilters = { ...filters };

        // Kalau bukan super admin, set branch_id
        if (role === 'admin') {
            newFilters['filter[branch_id]'] = user?.branch_id || '';
            dispatch(setFilters(newFilters));
        }

        dispatch(getAllOrder(newFilters)); // gunakan newFilters, bukan filters lama
    }, [dispatch, refetch]);

    // Auto-refresh setiap 10 menit dengan filter yang ada
    useEffect(() => {
        const autoRefreshInterval = setInterval(() => {
            // Gunakan filter terbaru dari ref
            const user = JSON.parse(localStorage.getItem('USER'));
            const role = GetAdminRole(user);

            let newFilters = {
                ...filters, 
                'filter[user.name]': '',
                'page': 1
            };

            // Kalau bukan super admin, set branch_id
            if (role === 'admin') {
                newFilters['filter[branch_id]'] = user?.branch_id || '';
                dispatch(setFilters(newFilters));
            }
            dispatch(setFilters(newFilters));
            dispatch(getAllOrder(newFilters));
        }, 10 * 60 * 1000); // 10 menit = 10 * 60 * 1000 ms

        // Cleanup interval saat komponen unmount
        return () => clearInterval(autoRefreshInterval);
    }, []); // Empty dependency array agar hanya sekali setup


    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <Fragment>
            <Col md="12" className="project-list">
                <Card className="px-3">
                    <FindOrder />
                </Card>
            </Col>
            <Col xl="12" className="xl-80">
                <Row>
                    {loading && (
                        <CustomLoader />
                    )}
                    { loading === false && orders.length === 0 ? (
                        <Col md="12">
                            <div className="no-data-found d-flex flex-column align-items-center justify-content-center" style={{ height: '300px' }}>
                                <i className="fa fa-search" style={{ fontSize: '100px', color: '#ccc', marginBottom: '20px' }}></i>
                                <h5 style={{ fontSize: '24px' }}>Data tidak ditemukan</h5>
                            </div>
                        </Col>
                    ) : (
                        <OrderContent setRefetch={setRefetch} />
                    )}
                </Row>
                </Col>
        </Fragment>
    );
};

export default OrderContain;